import { parse as parseCsv } from 'papaparse';
import { SetColumn } from '../../../types';

export type ImportFromCsvProps<TItem, TRow> = {
  columns: SetColumn<TItem, string>[];
  getItem: (row: TRow, index: number) => TItem;
  text: string;
};

/** Import CSV data and leave its typing alone. */
export function importFromCsv<
  TRow extends Record<string, string> = Record<string, string>
>(config: Pick<ImportFromCsvProps<TRow, TRow>, 'text'>): TRow[];
export function importFromCsv<
  TItem,
  TRow extends Record<string, string> = Record<string, string>
>(config: ImportFromCsvProps<TItem, TRow>): TItem[];
/** Import CSV data from a file. */
export function importFromCsv<
  TItem,
  TRow extends Record<string, string> = Record<string, string>
>({
  columns,
  getItem,
  text
}: Partial<ImportFromCsvProps<TItem, TRow>>): TItem[] {
  const { data, errors } = parseCsv<TRow>(text!, { header: true });
  if (errors.length) {
    throw new Error(errors.map(({ message }) => message).join('\n'));
  }

  return data.map((row, index) => {
    const item = (getItem) ? getItem(row, index) : (
      row as unknown as TItem
    );
    columns?.forEach((column) => {
      const value = row[column.label as keyof(TRow)].trim();
      if (typeof column.setter === 'function') {
        column.setter(item, value);
      } else {
        item[column.setter as keyof(TItem)] = (
          value as unknown as TItem[keyof(TItem)]
        );
      }
    });
    return item;
  });
}
